import React, { useState } from "react";
import {
  AddFormButton,
  CustomLoader,
  Icon,
} from "../../shared/components/TableElements";
import useClickAway from "../../shared/custom-hooks/useClickAway";
import format from "date-fns/format";
import { useTranslation } from "react-i18next";
import { NATEXT } from "../../shared/constants";
import { ColumnReOrderButtonContainer } from "../../shared/components/table/components/ColumnReorder";
import { getDisplayDateWithTimeNew, getListingDisplayDate } from "../../shared/helpers";
import styled from "styled-components";
import { right, left } from "../../utils/directions";

const ReportCard = ({
  report,
  onEditReport,
  onRunReport,
  isRunning,
  onDelete,
}) => {
  const { t } = useTranslation("common");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const clickAwayRef = useClickAway({
    handleCloseElement: () => setIsMenuOpen(false),
  });
  return (
    <div key={report.report_id} className="col-12 col-sm-6 col-lg-4">
      <div className="card h-100 shadow-sm position-relative">
        <div className="card-body d-flex flex-column">
          <div className="d-flex justify-content-between align-items-start mb-2">
            <h5 className="card-title flex-grow-1 pe-2">
              {report.report_name}
            </h5>
            <div ref={clickAwayRef} style={{ position: "relative" }}>
              <ColumnReOrderButtonContainer
                onClick={() => setIsMenuOpen((prev) => !prev)}
                role="button"
              >
                <Icon className="fi fi-rr-menu-dots-vertical text-muted cursor-pointer"></Icon>
              </ColumnReOrderButtonContainer>
              {isMenuOpen && (
                <DropdownMenu className="dropdown-menu show position-absolute mt-2">
                  <button
                    type="button"
                    onMouseDown={(e) => e.stopPropagation()}
                    className="dropdown-item"
                    onClick={() => {
                      onEditReport(report);
                    }}
                  >
                    {t("edit")}
                  </button>
                  <button
                    type="button"
                    className="dropdown-item text-danger"
                    onClick={() => {
                      setIsMenuOpen(false);
                      onDelete(report);
                    }}
                  >
                    {t("delete")}
                  </button>
                </DropdownMenu>
              )}
            </div>
          </div>
          <div className="d-flex gap-2 align-items-center">
            <i className="fi fi-rr-calendar-day"></i>
            <p className="text-muted small mb-1">
              {`${t("created")} ${getListingDisplayDate(report?.created_at)}`}
            </p>
          </div>
          <p className="text-muted small mb-3">
            {`${t("last_run")}: ${
              report.last_run
                ? getDisplayDateWithTimeNew(report.last_run)
                : NATEXT
            }`}
          </p>
          <div className="mt-auto">
            <AddFormButton
              className="w-100 d-flex align-items-center gap-2"
              onClick={() => onRunReport(report)}
              disabled={isRunning}
            >
              {isRunning ? (
                <CustomLoader />
              ) : (
                <>
                  <i
                    className="fi fi-rr-play"
                    style={{ position: "relative", top: "2px" }}
                  ></i>
                  <p className="text-white">{t("run_report")}</p>
                </>
              )}
              {/* <i
                className="fi fi-rr-play"
                style={{ position: "relative", top: "2px" }}
              ></i>
              <p className="text-white">{t("run_report")}</p> */}
            </AddFormButton>
          </div>
        </div>
      </div>
    </div>
  );
};

const DropdownMenu = styled.div`
  ${right}: 0;
  ${left}: auto;
`;

export default ReportCard;
